module.exports = __webpack_public_path__ + "static/media/address-business.29fae989.svg";